import React, { forwardRef, memo, useCallback } from 'react';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { Dialog, DialogContent, DialogTitle } from '../../components/material-ui/Dialog';
import { LoginForm } from '../../components/LoginPage/LoginForm/LoginForm';
import { MessageDialogTypes } from '../../components/MessageDialog/MessageDialog';
import { useStep } from '../../components/LoginPage/hooks/useStep';
import { useMobileWidth } from '../../components/hooks/useMobileWidth';
import { relogin, SHOW_ERROR } from '../../actions/login';
import { showConfirmDialog } from '../../actions/messageDialog';
import { useHideModal } from '../../actions/modal';
import { useStyles } from './useStyles';

export const Relogin = memo(
    forwardRef((props, ref) => {
        const classes = useStyles();
        const hideModal = useHideModal();
        const { isMobilePortrait } = useMobileWidth();
        const dispatch = useDispatch();
        const { error } = useSelector((state) => get(state, 'login', {}));
        const { step, showStep } = useStep();
        const { t: translate } = useTranslation();

        const handleSuccess = useCallback(() => {
            hideModal();
            dispatch(
                showConfirmDialog({
                    title: translate('loginPage.loginSuccess'),
                    message: translate('messages.repeatLastAction'),
                    btnCancelVisibility: false,
                    options: {
                        type: MessageDialogTypes.SUCCESS,
                    },
                })
            );
        }, []);

        const handleLogin = useCallback(
            (username, password, isEng, confirmationCode, onError) => {
                dispatch({
                    type: SHOW_ERROR,
                    error: '',
                });
                dispatch(relogin({ username, password, eng: isEng, confirmationCode, onError, onSuccess: handleSuccess }));
            },
            [handleSuccess]
        );

        return (
            <Dialog open={true} maxWidth="md" fullScreen={isMobilePortrait} onClose={hideModal}>
                <DialogTitle className={classes.title}>{translate('modal.loginDialog')}</DialogTitle>
                <DialogContent className={classes.content} ref={ref}>
                    <LoginForm onLogin={handleLogin} error={error} dark={false} step={step} showStep={showStep} isWhiteColor={false} />
                </DialogContent>
            </Dialog>
        );
    })
);
